import { z } from 'zod';
import { zPrice } from './primitives';

/**
 * Used to provide aggregate data for a single day.
 */
export const dayReportSchema = z.object({
  restaurantId: z.string(),
  year: z.number(),
  month: z.number(),
  day: z.number(),
  ordersCount: z.number(),
  eftposAmount: z.number(),
  eftposPaymentsCount: z.number(),
  cashAmount: z.number(),
  cashPaymentsCount: z.number(),
  onlineAmount: z.number(),
  onlinePaymentsCount: z.number(),
  totalAmount: z.number(),
  totalPaymentsCount: z.number(),

  // loyaltyDiscounts?
  // 100 percent discounts?
  // otherDiscounts?

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type DayReport = z.output<typeof dayReportSchema>;

export const dayReportStrictSchema = dayReportSchema.safeExtend({
  year: z.int().positive(),
  month: z.int().positive(),
  day: z.int().positive(),
  ordersCount: z.int().nonnegative(),
  eftposAmount: zPrice,
  eftposPaymentsCount: z.int().nonnegative(),
  cashAmount: zPrice,
  cashPaymentsCount: z.int().nonnegative(),
  onlineAmount: zPrice,
  onlinePaymentsCount: z.int().nonnegative(),
  totalAmount: zPrice,
  totalPaymentsCount: z.int().nonnegative(),
});

// Convex types
export const dayReportCvxSchema = dayReportSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type DayReportCvx = z.output<typeof dayReportCvxSchema>;
